/**
 *
 * @param {string} value - input value to convert to currency string
 * @return {string} value - input value with dollar sign, commas, and decimals added
 *
 * Turns input into a number, then a currency string
 */
function formatCurrency(value) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });

  const formattedValue = value.replace(/\D/g, '');

  const currencyFormat = formatter.format(formattedValue);

  value = `${currencyFormat}`;

  return value;
}

export default formatCurrency;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/formatCurrency.js